import React from "react";
import styled from "styled-components";

export const Paragraph = styled((props) => <p {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_p_${props?.automationidattr?.replace(/ /g, "")}_1"`,
  })
)`
  font-family: "Roboto" !important;
  font-weight: 400 !important;
  color: #282828;
  font-size: 16px;
  text-align: left;
`;
